export default () => {
  /* istanbul ignore else */
  if (process.env.GRAPHQL_MOCK) {
    return require('../../mocks/main-apollo-client-mock').default; // eslint-disable-line global-require
  } else {
    return require('./clients/main-apollo-client').default; // eslint-disable-line global-require
  }
};
